<template>
    <div class="mysection">
        <h1><img src="../../assets/images/wx_logo_ss.png" border="0" />登录普惠投融平台</h1>
        <div class="login_wx">
            <!-- <h3>用户登录</h3> -->
           <el-form ref="form" :model="form" :rules="LoginRules">
                <el-form-item label="" prop="username">
                    <el-input v-model="form.username" size="large" placeholder="输入昵称" @keyup.enter.native="onSubmit"></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                    <el-input  v-model="form.password" type="password" size="large" placeholder="输入密码" @keyup.enter.native="onSubmit"></el-input>
                </el-form-item>
                <div class="cbox">
                    <a class="find_pwd" @click="toForgetPwd(openid,wxstate)">找回密码?</a>
                    <el-checkbox v-model="form.checked" checked>记住密码</el-checkbox>
                </div>
                <el-button type="primary" size="large" class="btn_login" @click.native.prevent="onSubmit(openid,wxstate)" :loading="logining">登录</el-button>
            <!--<div class="forget_pwd">-->
                <!--<router-link :to="{path:'mp'}">免费注册</router-link>-->
                <!--<router-link :to="{path:'wxForgetPassword'}">找回密码</router-link>-->
            <!--</div>-->
           </el-form>
        </div>
    </div>
</template>
<script>
    import {reqGetWxLogin,reqWxLoginByChangePwd} from '../../api/weixin-api'
    export default {
        data(){
            return{
              openid:'',
              wxstate:'',
              x:'',
              projectDetail:'',
                logining:false,
                form: {
                    username:'',
                    password: '',
                    checked: true
                },
                LoginRules: {
                    username: [
                        {required: true, message: '请输入昵称', trigger: 'blur'},
                    ],
                    password: [
                        {required: true,message: '请输入密码',trigger: 'blur'},
                    ],
                },
            }
        },
        methods: {
          gobackFirstPage: function () {
            this.$store.dispatch('showHF');
            this.$router.push({path: '/'});
          },
          toForgetPwd: function (openid,wxstate) {
            this.$router.push({path: 'wxForgetPassword',query:{openid:openid,wxstate:wxstate}});
          },
          onSubmit(openid, wxstate) {
            console.info("=====(onSubmit按钮)登录时带上openid判断,另外检验openid是否存在===" + openid);
            console.info("=====(onSubmit按钮)登录时带上wxstate判断,另外检验wxstate是否存在===" + wxstate);
            var that = this;
            if(openid&&wxstate){

            this.$validator.validateAll().then(result => {
              if (!result) {
                this.$message({
                  message: '请填写符合规则的信息',
                  type: 'warning'
                });
                return false;
              }
              let para = {
                username: that.form.username,
                password: that.form.password,
                openid: openid
              };
              this.$refs.form.validate((valid) => {
                if (valid) {
                  this.logining = true;
                  reqGetWxLogin(para).then((res) => {
                    if (res.code === 1) {
                      this.logining = false;
                      if (this.form.checked == true) {
                        console.info(this.form.checked);
                        that.setCookie(that.form.username, 7)
                      } else {
                        console.info(this.form.checked);
                        this.clearCookie();
                      }
                      localStorage.setItem('Authorization', res.data.token);
                      if (wxstate) {
                        if (wxstate.indexOf("PLR") != -1) {
                          var i = wxstate.indexOf("PLR");
                          var x=wxstate.indexOf("WX");
                          this.i=i;
                          this.x=x;
                          this.projectId = wxstate.substring(0, this.i);
                          this.projectType=wxstate.substring(this.i+3,this.x);
                          this.projectDetail=wxstate.substring(this.x+2,wxstate.length);
                          if (this.projectType === 'borrow') {
                            this.$router.push({
                              name: 'wxBorrowProjectDetail',
                              query: {id: this.projectId, token: res.data.token,projectDetail:this.projectDetail}
                            });
                          } else if (this.projectType === 'loan') {
                            this.$router.push({
                              name: 'wxLoanProjectDetail',
                              query: {id: this.projectId, token: res.data.token,projectDetail:this.projectDetail}
                            });
                          } else {
                            this.$router.push({
                              name: 'wxAssignmentDebtDetail',
                              query: {id: this.projectId, token: res.data.token,projectDetail:this.projectDetail}
                            });
                          }
                        }else if(wxstate.indexOf("PLL")!=-1){
                          var i=wxstate.indexOf("PLL");
                          var x=wxstate.indexOf("WX");
                          this.i=i;
                          this.x=x;
                          this.projectId=wxstate.substring(0,this.i);
                          this.projectType=wxstate.substring(this.i+3,this.x);
                          this.projectDetail=wxstate.substring(this.x+2,wxstate.length);
                          if(this.projectType === 'borrow'){
                            this.$router.push({name: 'wxBorrowProjectDetail', query: {id: this.projectId,token:res.data.token,projectDetail:this.projectDetail}});
                          }else if(this.projectType === 'loan'){
                            this.$router.push({name: 'wxLoanProjectDetail', query: {id: this.projectId,token:res.data.token,projectDetail:this.projectDetail}});
                          }else {
                            this.$router.push({name: 'wxAssignmentDebtDetail', query: {id: this.projectId,token:res.data.token,projectDetail:this.projectDetail}});
                          }
                        }else if(wxstate.indexOf("UID")!=-1){
                          this.$router.push({name: 'wxProjectList'});
                        }else {
                          this.$router.push({path: 'wxMyHomePage', query: {token: res.data.token}})
                        }
                      }
                    } else if (res.code === 0) {
                      this.$message({
                        message: '对不起，账户或者密码错误,请仔细核实后登录',
                        type: 'warning'
                      });
                      this.logining = false;
                    } else {
                      this.$message({
                        message: '对不起，登录失败',
                        type: 'warning'
                      });
                      this.logining = false;
                    }
                  })
                } else {
                  console.log('error submit!!');
                  return false;
                }
              });
            }).catch(() => {
            });
            }else {
// 用户中心修改密码后重新登录(只是简单的登录和授权无关)
              this.$validator.validateAll().then(result => {
                if (!result) {
                  this.$message({
                    message: '请填写符合规则的信息',
                    type: 'warning'
                  });
                  return false;
                }
                let para = {
                  username: that.form.username,
                  password: that.form.password,
                };
                this.$refs.form.validate((valid) => {
                  if (valid) {
                    this.logining = true;
                    reqWxLoginByChangePwd(para).then((res) => {
                      if (res.code === 1) {
                        this.logining = false;
                        if (this.form.checked == true) {
                          console.info(this.form.checked);
                          that.setCookie(that.form.username, 7)
                        } else {
                          console.info(this.form.checked);
                          this.clearCookie();
                        }
                        localStorage.setItem('Authorization', res.data.token);
                        this.$router.push({path: 'wxMyHomePage', query: {token: res.data.token}})
                      } else if (res.code === 0) {
                        this.$message({
                          message: '对不起，账户或者密码错误,请仔细核实后登录',
                          type: 'warning'
                        });
                        this.logining = false;
                      } else {
                        this.$message({
                          message: '对不起，登录失败',
                          type: 'warning'
                        });
                        this.logining = false;
                      }
                    })
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });
              }).catch(() => {
              });
            }

          },

            // 设置cookie
            setCookie (username, exdays) {
                var exdate = new Date()
                exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)// 保存的天数
                // 字符串拼接cookie
                window.document.cookie = 'webUsername' + '=' + username + ';path=/;expires=' + exdate.toGMTString()
            },
            // 读取cookie
            getCookie: function () {
                var that = this;
                if (document.cookie.length > 0) {
                    var arr = document.cookie.split('; ');
                    for (var i = 0; i < arr.length; i++) {
                        var arr2 = arr[i].split('=');
                        // 判断查找相对应的值
                        if (arr2[0] === 'webUsername') {
                            that.form.username = arr2[1]// 保存到保存数据的地方
                        }
                    }
                }
            },
            // 清除cookie
            clearCookie: function () {
                this.setCookie('', '', -1)
            },
            pressEnter: function (event) {
                if(event.keyCode ==13){
                    this.onSubmit();
                }
            },
          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          toWxCompleteInfo:function(openid,wxstate) {
            pushHistory();

            function bodyScroll() {
              window.location.href = '/mp?openid='+openid+'&wxstate='+wxstate;
              window.removeEventListener("popstate", bodyScroll, false);
            }

            window.addEventListener("popstate", bodyScroll, false);

            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          },
          backWxProjectList:function() {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxProjectList';
            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          },
          backWxLogin:function() {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxLogin';
            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          }
        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.openid=this.$route.query.openid;
            this.wxstate=this.$route.query.state;
            if(this.wxstate && this.openid){
              if(this.wxstate.indexOf('PLL')!=-1) {
                this.backWxProjectList();
              }
              else{
                this.toWxCompleteInfo(this.openid, this.wxstate);
              }
            }else{
              this.backWxLogin();
            }
            this.isWechatBrowser();
        },
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxLogin.vue